import forEach from "lodash/forEach";
import { HIGHLIGHT_NODES_DELAY } from "../constants";
let timer = null;
export default (graphComponentRef, nodes) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.div.isConnected) || !nodes.length)
        return;
    timer && clearTimeout(timer);
    forEach(nodes, (node) => {
        var _a;
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.highlightIndicatorManager.addHighlight(node);
    });
    timer = setTimeout(() => {
        var _a, _b;
        if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.div.isConnected))
            return;
        (_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.highlightIndicatorManager.clearHighlights();
    }, HIGHLIGHT_NODES_DELAY);
};
